/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusDropdownMiniDto } from '../../models/lexplus-dropdown-mini-dto';

export interface StandorteControllerGetStandortDropdownOptionsV1$Params {
  funktionIds?: Array<number>;
  standortId?: number;
  onlyAssigned?: boolean;
  onlyWritable?: boolean;
}

export function standorteControllerGetStandortDropdownOptionsV1(http: HttpClient, rootUrl: string, params?: StandorteControllerGetStandortDropdownOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusDropdownMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, standorteControllerGetStandortDropdownOptionsV1.PATH, 'get');
  if (params) {
    rb.query('funktionIds', params.funktionIds, {});
    rb.query('standortId', params.standortId, {});
    rb.query('onlyAssigned', params.onlyAssigned, {});
    rb.query('onlyWritable', params.onlyWritable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusDropdownMiniDto>>;
    })
  );
}

standorteControllerGetStandortDropdownOptionsV1.PATH = '/v1/standorte/standort/dropdown-options';
